/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useFirestore } from '../../../hooks/useFirestore';
import Loading from '../../../components/loading';
import NavbarAdmin from '../../../components/navbarAdmin';
import Tabela from '../../../components/tabela';
import * as XLSX from 'xlsx';
import { FaFileArrowDown } from 'react-icons/fa6';

export default function Relatos(params) {
  const [relatos, setRelatos] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [naoLidos, setNaoLidos] = useState(0)

  const { buscaRelatos, buscaRelatorios } = useFirestore()

  useEffect(() => {
    getRelatos()
  }, [])

  const getRelatos = () => {
    buscaRelatos().then((res) => {
      setRelatos(res)
      buscaNaoLidos(res)
      setIsLoading(false)
    })
  }

  const buscaNaoLidos = (r) => {
    let count = 0
    r.map((item) => item.lido === false || item.lido === undefined ? count++ : 0)
    setNaoLidos(count)
  }

  const buscaJson = () => {
    buscaRelatorios().then((res) => geraXLSX(res))
  }

  const geraXLSX = (data) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Relatorios");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "relatorio_" + new Date().toLocaleDateString() + "_" + new Date().toLocaleTimeString() + ".xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  return (
    <div className='bg-background h-screen'>
      {
        isLoading ?
          <Loading isLoading={isLoading} />
          :
          <>
            <NavbarAdmin />
            <main className='flex flex-col'>
              <section className='lg:w-4/6 md:w-5/6 w-11/12 mx-auto mt-8'>
                <div className='flex justify-between mb-8'>
                  <h1 className='flex text-primary items-center text-3xl gap-4 font-semibold'>Caixa de entrada ({naoLidos})</h1>
                  <button className="bg-primary flex items-center gap-2 px-4 py-2 text-white rounded-md" onClick={buscaJson}>Baixar Relatório <FaFileArrowDown/></button>
                </div>
                <hr className='border-background shadow mb-8' />
              </section>
              <section className='lg:w-4/6 md:w-5/6 w-11/12 mx-auto'>
                <Tabela lista={relatos} callBack={getRelatos} />
              </section>
            </main>
          </>
      }
    </div>
  )
};
